import React, { createContext, useContext, useState } from '../../../_snowpack/pkg/react.js';
import mitt from '../../../_snowpack/pkg/mitt.js';
export const MediasDndEvents = mitt();
export { default as Drop } from './drop.js';
export const MediasDnDContext = /*#__PURE__*/createContext({});
export function useMediasDnDContext() {
  return useContext(MediasDnDContext);
}
export function MediasDnDContextProvider({
  children
}) {
  const [active, setActive] = useState(false);
  const [,] = useState();
  return /*#__PURE__*/React.createElement(MediasDnDContext.Provider, {
    value: {
      active,
      setActive
    }
  }, children);
}